/**
 * 文件定位：
 * 1. 当前文件位于 cad-core/mesh/feature/extrude 层；
 * 2. 负责定义拉伸族预览体对象；
 * 3. 该对象统一承载拉伸凸台/切除的创建态与编辑态预览。
 */

import type * as THREE from 'three';
import type { ExtrudeFeaturePrototype } from '../../../feature/prototype/extrude/ExtrudeFeaturePrototype';
import type { ExtrudeFeatureDefinitionModel } from '../../../feature/definition/extrude/ExtrudeFeatureDefinition';
import { FeaturePreviewObject } from '../FeaturePreviewObject';

/**
 * 拉伸族预览体对象。
 */
export class ExtrudePreviewObject extends FeaturePreviewObject<
    ExtrudeFeaturePrototype,
    ExtrudeFeatureDefinitionModel
> {
    /**
     * @param input 输入参数。
     */
    public constructor(input: {
        prototype: ExtrudeFeaturePrototype;
        draftDefinition: ExtrudeFeatureDefinitionModel;
        meshData: MeshData;
        geometry: THREE.BufferGeometry;
        material: THREE.Material | THREE.Material[];
    }) {
        super(input);
    }
}
